
export default "/assets/chevron-down-micro.7508ea9f.svg"